export const minimize = {
  name: "minimize" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.788 9.74a.875.875 0 0 1-.875.874h-5.782a.75.75 0 0 1-.75-.75V4.083a.875.875 0 1 1 1.75 0v3.544l4.674-4.674a.875.875 0 0 1 1.237 1.238L16.37 8.864h3.544c.483 0 .875.392.875.875Zm-17.58 4.518c0-.483.391-.875.875-.875h5.781a.75.75 0 0 1 .75.75v5.782a.875.875 0 1 1-1.75 0V16.37l-4.673 4.674a.875.875 0 0 1-1.238-1.238l4.674-4.673H4.083a.875.875 0 0 1-.875-.875Z" clip-rule="evenodd"/></svg>`,
  keywords: ["minimize"],
  category: "action" as const,
};
